import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerService } from 'ng-zorro-antd/drawer';


@Component({
    selector: 'app-quicktransfer',
    templateUrl: './bankdetails.component.html',
    styleUrls: ['./bankdetails.component.css']
})
export class BankDetailsComponent implements OnInit{
    @Input() banks:  string[];
    loading = false;
    searchTerm: string = '';
    width = (window.innerWidth / 3) * 2;
    visible = false;

    constructor(private modal: NzModalService , private ds: NzDrawerService){

    }
    
    ngOnInit(): void {
       
    }
    close(): void {
      this.visible = false;
    }


    get filteredBanks(): string[] {
        if (!this.searchTerm) {
          return this.banks; 
        }
        return this.banks.filter(bank =>
          bank.toLowerCase().startsWith(this.searchTerm.toLowerCase())
        ); 
      }
      
      
}